import React from "react";
import CheckBox from "../obra/CheckBox";
import { IonItem, IonLabel, IonButton } from "@ionic/react";
import AvancePickerMobile from "./AvancePickerMobile";

const SubdestajoMobile = ({ subdestajo, setSubdestajo }) => {
  const isComplete = (subdestajo) => {
    return (
      parseFloat(subdestajo.real) === 1 || parseFloat(subdestajo.progreso) === 1
    );
  };

  const setCantidad = (cantidad) => {
    cantidad -= parseInt(subdestajo.progreso);
    createAvance(cantidad);
  };

  const createAvance = (cantidad) => {};

  return (
    <IonItem
      key={subdestajo.idDestajo}
      className="py-2"
      lines="none"
      style={
        parseFloat(subdestajo.progreso) > 100
          ? { "--background": "#fffaea" }
          : undefined
      }
    >
      <IonLabel className="ion-text-wrap" color="primary">
        <div className="d-flex align-items-center">
          <CheckBox checked={isComplete(subdestajo)} disabled />
          <span className="bold ps-2 flex-grow-1">{subdestajo.nombre}</span>
          <IonButton
            fill="light"
            onClick={(e) => {
              e.preventDefault();
              e.stopPropagation();
              setSubdestajo(subdestajo);
            }}
            className="border-0 mx-0 px-1 bg-white"
            style={{ color: "#b76d4f" }}
          >
            <i className="fa fa-info"></i>
          </IonButton>
        </div>
        <div className="mt-2">
          <AvancePickerMobile
            permitirExcedente
            limite={100}
            intervalo={1}
            setCantidad={setCantidad}
            progreso={subdestajo.progreso}
          />
        </div>
      </IonLabel>
    </IonItem>
  );
};

export default SubdestajoMobile;
